import { createAction, props } from '@ngrx/store';
import { type } from '../../helpers/util';
import { User } from 'oidc-client';
export const actionTypes = {
    SET_ORIGINAL_URL : type('[AuthData] set URL being accessed for first time'),
    SET_USER_DATA : type('[AuthData] set user data post successful login'),
};
export const SetOriginalURLAccessedAction = createAction('[AuthData] set URL being accessed for first time', props<{payload:string}>());
export const SetLoggedInUserDataAction = createAction('[AuthData] set user data post successful login', props<{payload:User}>());

